import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import SideContentBlock from "./../../../shared/sideContentBlock";
import IntelligenceMapWrapper from "./../intellegence/intelligenceMapWrapper";
import IntelligenceCars from "./../intellegence/intelligenceCars";
import { withIntelligenceControl } from "../../../shared/containers/containerIntelligenceControl";

import styles from "./carData.module.scss";

const CarData = (props) => {
  const { fullScreen } = props;

  return (
    <Scrollbars style={{ height: "100%" }} autoHide={true}>
      <div className={styles.carData}>
        <div className={styles.carData_container}>
          <SideContentBlock>
            <IntelligenceMapWrapper />
          </SideContentBlock>
        </div>

        <div className={fullScreen ? styles.carData_containerFull : styles.carData_container}>
          <SideContentBlock minHeight={fullScreen ? "500px" : null}>
            <IntelligenceCars />
          </SideContentBlock>
        </div>
      </div>
    </Scrollbars>
  );
};

export default withIntelligenceControl(React.memo(CarData));
